import { UserCreateDTO } from "../services/user.service.types";
import { RoleFormData, UserFormData } from "../pages/user-form-types";

// Add the mapper function
const mapUserFormDataToUserCreateDTO = (formData: UserFormData, roles: RoleFormData[]): UserCreateDTO => {
    // Find the selected role to check if it's an organizer
    const selectedRole = roles.find(role => role.id === formData.role);
    const isOrganizer = selectedRole?.name === 'organizer';

    return {
        name: formData.name.trim(),
        email: formData.email.trim(),
        mobileNumber: formData.mobileNumber,
        status: formData.status.toLowerCase(),
        role: formData.role,
        // Only include region and local if the role is organizer
        region: isOrganizer ? formData.region : null,
        local: isOrganizer ? formData.local : null
    };
};

export { mapUserFormDataToUserCreateDTO };